// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__FmSLe","info":"Note_info__2qRR6","note":"Note_note__1MmAl","actions":"Note_actions__1_7gl"};